import React, { useRef, useEffect, useMemo } from 'react'
import './gotosite.css'
import { NoImage, MsInSeconds } from '../../../constants'
import CountDown from './countdown/countdown'
import { BuildExternalURL } from '../../../../common/common'
import { setClickOut } from '../../../../utils/statistics'

type Props = {
    site: string,
    sitelink: string
}
const countDown = 1.5//s
const hideClass = 'd-none-important'

function GoToSite(props: Props) {
    const isAcsLink = props.sitelink.toLowerCase().indexOf("allcamsex.com") > -1;
    console.log(isAcsLink)
    const logo = useMemo(() => {
        try {
            return require(`../../../../images/main/sites-logo/goto/${props.site.toLowerCase()}.png`)
        } catch (error) {
            return NoImage
        }
    }, [props])

    const timerRef = useRef(-1)
    const sectionRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (sectionRef.current) {
            sectionRef.current.classList.remove(hideClass);

            timerRef.current = window.setTimeout(() => {
                const encodedLink = BuildExternalURL(props.sitelink)
                setClickOut(props.site, () => {
                    window.location.href = encodedLink;
                });
            }, countDown * MsInSeconds)
        }
    }, [props.sitelink])


    function handleClick(): void {
        if (timerRef.current) {
            clearInterval(timerRef.current)
        }
        if (sectionRef.current) {
            sectionRef.current.classList.add(hideClass);
        }
    }
    return <section ref={sectionRef} className={`block-screen go-to-site ${hideClass}`}>
        <div className='center-content content bg-white'>
            <div className='color-black position-absolute close' onClick={() => handleClick()}>
                &times;
            </div>
            <p className='go-to-text text-center color-light-blue'>YOU’RE BEING REDIRECTED </p>
            <p className='go-to-text text-center color-light-blue'>
                TO{" "}
                {isAcsLink ? 
                <img className='' src={require("../../../../images/main/sites-logo/goto/allcamsex.png")} alt="allcamsex" />
                 : <img className={`goto-${props.site.toLowerCase()}`} src={logo} alt={props.site} />
                }
                {props.site.toLowerCase() != "allcamsex" && isAcsLink ? "TO ENJOY" : ""}
            </p>
            {props.site.toLowerCase() != "allcamsex" && isAcsLink
            ? <p className='go-to-text text-center color-light-blue'><img className={`goto-${props.site.toLowerCase()}`} src={logo} alt={props.site} />{" "}MODELS</p>
            : null
            }
            <CountDown seconds={countDown} />
            <a href={props.sitelink} className='margin-top-20 text-center text-decoration-u d-table center-h color-light-blue F18'>Take Me There!</a>
        </div>
    </section>
}
export default GoToSite